export default class QueryWhereItem
{
	remoteClass = "gongqi.erp.gotmodel.sqlquery.QueryWhereItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	value;	//String
		
	andOr;	//String
	leftBracket;	//String	//QueryWhereLeftBracket
	rightBracket;	//String	//QueryWhereRightBracket
		
	label;	//String
	status;	//String			//QueryWhereStatus
	fieldType;	//String	//QueryWhereFieldType
	
	tag;	//String
	type;
	fieldValue;
}


// WEBPACK FOOTER //
// ./src/universalView/remote/QueryWhereItem.js